"use server";

import { cookies } from "next/headers";
import { type Lang, LANG_COOKIE } from "@/lib/i18n";

export async function setLang(lang: Lang) {
  if (lang !== "en" && lang !== "ar") return;
  (await cookies()).set(LANG_COOKIE, lang, { path: "/", maxAge: 365 * 24 * 60 * 60, sameSite: "lax" });
}
